import "./quotation_component.css"

import { useState } from "react";
import axios from 'axios';

import AW from "../../../assets/Images/Elements/ArrowBlack.svg"
import AB from "../../../assets/Images/Elements/ArrowWhite.svg"

import instagram from "../../../assets/Images/Elements/Instagram.svg"
import LinkedIn from "../../../assets/Images/Elements/LinkedIn.svg"

export default function QuotationComponent() {
    const [fname, setFname] = useState('');
    const [fphone, setFphone] = useState('');
    const [fmessage, setFmessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const formData = new FormData();
        formData.append("name", fname);
        formData.append("phone", fphone);
        formData.append("message", fmessage);
        
        try {
            const res = await axios.post("https://adstrate.in/quote.php", formData, {
            headers: { "Content-Type": "multipart/form-data" },
            });
            alert("Alert: " + res.data.message);
        } catch (err) {
            alert("Failed: " + (err.response?.data?.error || "Unknown error"));
        }
    }; 

    const [quotationPara, setQuotationPara] = useState(1);
    const TOTAL_SLIDES = 3;

    const nextSlide = () => {
        setQuotationPara(prev =>
            prev === TOTAL_SLIDES ? 1 : prev + 1
        );
    };

    const prevSlide = () => {
        setQuotationPara(prev =>
            prev === 1 ? TOTAL_SLIDES : prev - 1
        );
    };

    return (
        <div>
            <div className="Quotation-MainSection">
                <div className="Quotation-SliderSection">
                    <div className="Quotation-SliderSection-Box">
                        <div className="Quotation-SliderSection-Box-Info">
                                <p 
                                className={`Quotation-SliderSection-Box-Info Quotation-SliderSection-fade ${quotationPara === 1 ? "Quotation-SliderSection-show" : ""}`}
                                >
                                    As a top digital marketing company in Mumbai, we focus on measurable outcomes, ensuring your business grows and stays competitive.
                                </p>
                                <p className={`Quotation-SliderSection-Box-Info Quotation-SliderSection-fade ${quotationPara === 2 ? "Quotation-SliderSection-show" : ""}`}>
                                    From social media marketing in Mumbai to Instagram marketing agency campaigns, every plan is customized for your brand.
                                </p>
                                <p className={`Quotation-SliderSection-Box-Info Quotation-SliderSection-fade ${quotationPara === 3 ? "Quotation-SliderSection-show" : ""}`}>
                                    We manage all aspects of social media content creation and digital marketing, giving you peace of mind while achieving consistent growth.
                                </p>
                        </div>
                        <div className="Quotation-SliderSection-Box-Buttons">
                            <button onClick={prevSlide} ><img src={AW}/></button>
                            <button onClick={nextSlide} ><img src={AB}/></button>
                        </div>
                    </div>
                </div>
                <div className="Quotation-FormSection">
                    <div className="Quotation-FormSection-Main">
                        <div className="Quotation-FormSection-Main-Details">
                            <h2>Get Quote</h2>
                            <p>
                                Get a custom proposal from Adstrate, a leading digital marketing agency in Mumbai. We specialize in social media and Instagram marketing, plus content creation, to boost your digital presence and drive measurable growth.
                            </p>
                        </div>
                        <form onSubmit={handleSubmit}  className="Quotation-FormSection-Form">
                            <div className="Quotation-FormSection-Form-Input">
                                <label for="fname">Name</label>
                                <input type="text" name="fname" placeholder="Name" value={fname} onChange={(e) => setFname(e.target.value)}  required/>
                            </div>
                            <div className="Quotation-FormSection-Form-Input">
                                <label for="fphone">Phone No</label>
                                <input type="text" name="fphone" placeholder="Phone No" value={fphone} onChange={(e) => setFphone(e.target.value)} required/>
                            </div>
                            <div className="Quotation-FormSection-Form-Input">
                                <label for="fmessage">Message</label>
                                <textarea rows="6" name="fmessage" placeholder='Write something...' onChange={(e) => setFmessage(e.target.value)} required/>
                            </div>
                            <button>Get Quote</button>
                        </form>
                        <div className="Quotation-ContactSection-Main">
                            <div className="Quotation-ContactSection-Details">
                                <div className="Quotation-ContactSection-Details-Info">
                                    <p className="LinkLabel">Phone No:</p>
                                    <a href="tel:+918976050818">+91 8976 050 818</a>
                                </div>
                                <div className="Quotation-ContactSection-Details-Info">
                                    <a href="tel:+917666814040">+91 7666 814 040</a>
                                </div>
                                <div className="Quotation-ContactSection-Details-Info">
                                    <p className="LinkLabel">Email: </p>
                                    <a href="mailto:contact@adstrate.in">contact@adstrate.in</a>
                                </div>
                            </div>
                            <div className="Quotation-ContactSection-Socials">
                                <a href="https://www.instagram.com/adstrate_in/"><img src={instagram} alt="" /></a>
                                <a href="https://www.linkedin.com/in/adstrate-agency/"><img src={LinkedIn} alt="" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}